import React, { Fragment, useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import SwipeableViews from 'react-swipeable-views'; //paquete installado manual(npm i react-swipeable-views)
import { useTheme } from '@material-ui/core/styles';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button.js';
import { useParams } from 'react-router-dom';
import { Close, Edit, Save } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
//funcion  efecto transition
import { TabPanel, indexTab, useStyleTabs } from 'hooks/TabPanel';
import { useToasty, Toasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext.js';

import { wsGet, wsUpdate } from 'services/WService.js';

// Components Article Detail
import Resume from './Resume/Resume';
import ProductDetails from './ProductDetails/ProductDetails';
import PurchaseData from './PurchaseData/PurchaseData.js';
import SalesData from './SalesData/SalesData.js';
import Tax from './Tax/Tax.js';
import Inventory from './Inventory/Inventory.js';
import Other from './Other/Other.js';

// Nuevo producto
import NewProduct from '../New/NewProduct';
import { useModal } from 'hooks/useModal';
import UpdateImageModal from '../UpdateImageModal';

const useStyles = makeStyles({
  marginRight: {
    float: 'right',
  },
});

const tabsComponent = [
  {
    permission: ConstantPermissions.LOGI_PRODUCTS_SUMMARY_SHOW,
    component: Resume,
    label: 'Resumen',
  },
  {
    permission: ConstantPermissions.LOGI_PRODUCTS_SUMMARY_SHOW,
    component: ProductDetails,
    label: 'Combo',
  },
  {
    permission: ConstantPermissions.LOGI_PRODUCTS_PURCHASE_DATA_SHOW,
    component: PurchaseData,
    label: 'Datos de compra',
  },
  {
    permission: ConstantPermissions.LOGI_PRODUCTS_SALE_DATA_SHOW,
    component: SalesData,
    label: 'Datos de venta',
  },
  {
    permission: ConstantPermissions.LOGI_PRODUCTS_TAX_SHOW,
    component: Tax,
    label: 'Impuestos',
  },
  {
    permission: ConstantPermissions.LOGI_PRODUCTS_INVENTORY_SHOW,
    component: Inventory,
    label: 'Inventario',
  },
  {
    permission: ConstantPermissions.LOGI_PRODUCTS_OTHER_SHOW,
    component: Other,
    label: 'Otros',
  },
];

export default WithApp(function ProductDetail(props) {
  const claseStyleTab = useStyleTabs();
  const themeTab = useTheme();
  const classes = useStyles();
  const { id } = useParams();

  const [value, setValue] = useState(0);
  const [notify, showNotify] = useToasty();
  const [isUpdate, setIsUpdate] = useState(false); // Estado de de edición
  const [model, setOpen] = useModal();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const [productDetail, setProductDetail] = useState({});
  const [dataProduct, setDataProduct] = useState({ id: id });

  const inputChange = (e) => {
    setDataProduct({
      ...dataProduct,
      [e.target.name]: e.target.value,
    });
  };

  async function getProductDetail() {
    let response = await wsGet('logi/product', id);
    if (response.success) {
      setProductDetail(response.data);
      setDataProduct(response.data);
    }
  }

  async function updateProduct() {
    let dataChanging = {};
    for (let key in productDetail) {
      if (typeof productDetail[key] === 'boolean' || typeof dataProduct[key] === 'boolean'){
        if (productDetail[key] !== dataProduct[key]) {
          dataChanging[key] = dataProduct[key];
        }
        continue;
      }
      if (productDetail[key] != dataProduct[key]) {
        dataChanging[key] = dataProduct[key];
      }
    }

    if (Object.keys(dataChanging).length < 1) {
      return;
    }

    let response = await wsUpdate('logi/product', id, dataChanging);
    if (response.success) {
      showNotify(response.message);
      getProductDetail();
      setIsUpdate(false);
    } else {
      showNotify(response.message, 'error');
    }
  }

  const ButtonUpdate = () => {
    let showBtn = (
      <Button
        round
        justIcon
        color={props.themeContext.buttonColorWarning}
        className={classes.marginRight}
        onClick={() => setIsUpdate(true)}
      >
        <Edit />
      </Button>
    );
    if (isUpdate) {
      showBtn = (
        <>
          <Button
            round
            justIcon
            color={props.themeContext.buttonColorDanger}
            className={classes.marginRight}
            onClick={() => {
              setIsUpdate(false);
              setDataProduct(productDetail);
            }}
          >
            <Close />
          </Button>
          <Button
            round
            justIcon
            color={props.themeContext.buttonColorSuccess}
            className={classes.marginRight}
            onClick={() => updateProduct()}
          >
            <Save />
          </Button>
        </>
      );
    }
    return showBtn;
  };

  useEffect(() => {
    getProductDetail();
  }, []);

  return (
    <Fragment>
      <Toasty action={notify} />

      <UpdateImageModal
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        setProduct={setDataProduct}
      />

      {id != 0 ? (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div className={claseStyleTab.titleContainer}>
              <b>({productDetail.ItemCode})</b> {productDetail.ItemName}
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <div className={claseStyleTab.root}>
              <AppBar position="static" color="default">
                <Tabs
                  value={value}
                  onChange={handleChange}
                  indicatorColor="secondary"
                  textColor="secondary"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="tabs"
                >
                  {tabsComponent.map((item, i) => {
                    return item.hasOwnProperty('permission') ? (
                      <Tab label={item.label} {...indexTab(i)} key={i} />
                    ) : (
                      <Tab label={item.label} {...indexTab(i)} key={i} />
                    );
                  })}
                </Tabs>
              </AppBar>

              <SwipeableViews
                axis={themeTab.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={value}
                onChangeIndex={handleChangeIndex}
              >
                {tabsComponent.map((item, i) => {
                  return item.hasOwnProperty('permission') ? (
                    <AllowedGuard
                      permission={item.permission}
                      key={i}
                      component={
                        <h4>
                          <b>No tiene permiso</b>
                        </h4>
                      }
                    >
                      <TabPanel value={value} index={i} dir={themeTab.direction}>
                        <AllowedGuard permission={ConstantPermissions.LOGI_PRODUCTS_UPDATE}>
                          <GridItem xs={12}>
                            <ButtonUpdate />
                          </GridItem>
                        </AllowedGuard>
                        <item.component
                          isUpdate={isUpdate}
                          dataDetail={productDetail}
                          dataProduct={dataProduct}
                          setDataProduct={setDataProduct}
                          inputChange={inputChange}
                          showNotify={showNotify}
                          reload={getProductDetail}
                          setOpen={setOpen}
                        />
                      </TabPanel>
                    </AllowedGuard>
                  ) : (
                    <TabPanel value={value} index={i} dir={themeTab.direction} key={i}>
                      <item.component
                        isUpdate={isUpdate}
                        dataDetail={productDetail}
                        dataProduct={dataProduct}
                        setDataProduct={setDataProduct}
                        inputChange={inputChange}
                        showNotify={showNotify}
                        reload={getProductDetail}
                      />
                    </TabPanel>
                  );
                })}
              </SwipeableViews>
            </div>
          </GridItem>
        </GridContainer>
      ) : (
        <NewProduct productDetail={productDetail} reloadProduct={getProductDetail} setDataProduct={setDataProduct} />
      )}
    </Fragment>
  );
});
